<template>
  <van-tabs animated @change="onChangeTab" class="products-regular" sticky offset-top="46">
    <van-tab v-for="(val, ind) in tabbars" :title="val.name" :key="ind">
      <div class="the-top">
        <van-list class="list" v-model="val.loading" :immediate-check="false" :finished="val.finished" :finished-text="val.finishedText" :error.sync="val.error" error-text="请求失败，点击重新加载" @load="getMoreProduct">
          <auction-item v-for="item in val.product_list" :key="item.id" :item="item" />
          <!-- 无数据，显示空 -->
          <van-empty description="暂无产品" v-if="val.product_list.length == 0"></van-empty>
        </van-list>
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
import * as ProductApi from "@/api/product"
import { Tab, Tabs, Toast, Dialog, Tag, List, Empty, Progress } from "vant"
import AuctionItem from "../../../components/AuctionItem.vue"

export default {
  name: "TianProductsRegular1",
  components: {
    AuctionItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [List.name]: List,
    [Empty.name]: Empty,
    [Progress.name]: Progress
  },

  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      finishedText: "",
      currentIndex: 0,
      pageSize: 10,
      activeName: "全部拍品",
      tabbars: [
        {
          name: "全部拍品",
          tag: "all",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        },
        {
          name: "3个月内",
          tag: "three",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        },
        {
          name: "3-6个月",
          tag: "six",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        },
        {
          name: "6个月以上",
          tag: "twelve",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        }
      ]
    }
  },

  created() {
    this.onChangeTab(0)
  },

  methods: {
    onChangeTab(index) {
      this.currentIndex = index
      if (this.tabbars[index].product_list.length < 1) {
        this.getMoreProduct()
      }
    },

    getMoreProduct() {
      let current = this.tabbars[this.currentIndex]
      current.loading = true

      let index = this.currentIndex
      let investDuration = this.tabbars[index].tag
      let pageNo = this.tabbars[index].pageNo
      let productType = 5

      let pageSize = 10
      let the = this
      let timeout = 1000
      // 每次加载不超过15个产品，下拉加载更多
      ProductApi.list({
        investDuration,
        productType,
        pageNo,
        pageSize
      })
        .then((data) => {
          current.product_list = current.product_list.concat(data.list)

          if (current.pageSize === 0 && data.list.length === 0) {
            current.finishedText = "暂无产品"
          } else if (data.list.length < the.pageSize) {
            // current.finishedText = "已经到底了";
            current.finished = true
          }

          current.pageNo++
          current.loading = false
          // console.log(data.list)
        })
        .catch((e) => {
          current.loading = false
          current.error = true
          Toast(e.msg || e.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.the-top {
  padding-bottom: 52px;
}
::v-deep .van-hairline--top-bottom:after {
  border: none;
}
::v-deep .van-tab {
  color: #999;
}
::v-deep .van-tab--active {
  color: #333;
  font-weight: 700;
}
</style>
